export default __webpack_public_path__ + "static/media/kid05.7684c0ac.jpg";